module.exports = __webpack_public_path__ + "static/media/default_header.1fe91eb9.jpg";